var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"nav-link",class:{ 'nav-link--home': _vm.isHome },attrs:{"to":_vm.to}},[_c('app-icon',{staticClass:"nav-link__icon",attrs:{"name":_vm.icon,"scale":1.4,"hidden":""}}),_c('span',{staticClass:"nav-link__content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }